import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import KlarnaPaymentCategoryiOS from './klarnaPaymentCategory.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Group summary='enum KlarnaStep' mdxType="Group">
      <Item title='paymentSessionCreated(clientToken: String, paymentCategories: [KlarnaPaymentCategory])' mdxType="Item">
  Indicates a successful creation of a payment session. It caries `clientToken` string, which is used for validation purposes and `paymentCategories` of type `KlarnaPaymentCategory`, representing the available payment options for the user.
  <Group summary='Properties' open mdxType="Group">
    <Item title='clientToken' subtitle='<String>' mdxType="Item">
  </Item>
    <Item title='paymentCategories' subtitle='Array <KlarnaPaymentCategory?>' mdxType="Item">
    The list of available Klarna payment categories.
    <KlarnaPaymentCategoryiOS mdxType="KlarnaPaymentCategoryiOS" />
  </Item>
  </Group>
      </Item>
      <Item title='viewInitialized' mdxType="Item">
Indicates that the Klarna view has been initialized. This is the first step in the Klarna view handling process.
      </Item>
      <Item title='viewResized(height: CGFloat)' mdxType="Item">
Represents a change in the view's height, which may occur when the Klarna view adjusts to display different content. The `height` parameter specifies the new height of the view.
  <Group summary='Properties' open mdxType="Group">
    <Item title='height' subtitle='<CGFloat>' mdxType="Item">
  </Item>
  </Group>
      </Item>
      <Item title='viewLoaded(view: UIView?)' mdxType="Item">
Indicates that the Klarna view has finished loading its initial content and is ready for interaction. The `view` parameter represents the klarna view.
  <Group summary='Properties' open mdxType="Group">
    <Item title='view' subtitle='<UIView?>' mdxType="Item">
  </Item>
  </Group>
      </Item>
      <Item title='paymentSessionAuthorized(authToken: String, checkoutData: PrimerCheckoutData)' mdxType="Item">
  Indicates that the payment session has been successfully authorized. It carries an `authToken` string for subsequent operations that require authorization and `checkoutData` for showing the checkout results, after the merchant finishes the payment.
  <Group summary='Properties' open mdxType="Group">
    <Item title='authToken' subtitle='<String?>' mdxType="Item">
  </Item>
    <Item title='checkoutData' subtitle='<PrimerCheckoutData?>' mdxType="Item">
  </Item>
  </Group>
      </Item>
      <Item title='paymentSessionFinalizationRequired' mdxType="Item">
Signals that the payment session requires finalization step in order to be completed.
      </Item>
      <Item title='paymentSessionFinalized(authToken: String, checkoutData: PrimerCheckoutData)' mdxType="Item">
Indicates that the payment session has been successfully finalized. It carries an `authToken` string for subsequent operations that require authorization and `checkoutData` for showing the checkout results, after the merchant finishes the payment.
  <Group summary='Properties' open mdxType="Group">
    <Item title='authToken' subtitle='<String?>' mdxType="Item">
  </Item>
    <Item title='checkoutData' subtitle='<PrimerCheckoutData?>' mdxType="Item">
  </Item>
  </Group>
      </Item>
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      